var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"test-form-question-description",domProps:{"innerHTML":_vm._s(_vm.question.name)}}),_vm._v(" "),_c('explanation',{ref:"explanation",attrs:{"question":_vm.question}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002da7f8","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/elements/QuestionName.vue
// module id = IkNQ
// module chunks = 0 1